import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {HttpService} from 'src/app/core';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-floorplan-delete-confirm-dialog',
  templateUrl: './delete-confirm-dialog.component.html',
  styleUrls: ['./delete-confirm-dialog.component.scss']
})

export class DeleteConfirmDialogComponent implements OnInit {

  project: any;
  floorPlan: any;

  constructor(
    private dialogRef: MatDialogRef<any>,
    private httpService: HttpService,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.floorPlan = this.data.floorPlan;
    this.project = this.data.project;
  }

  cancel() {
    this.dialogRef.close();
  }

  confirm() {
    this.httpService.deleteFloorPlans(this.floorPlan.id).subscribe((res: any) => {
      console.log(res);
      if (res.code === 1) {

        this.dialogRef.close({floorPlan: this.floorPlan});
        this.toastr.success('Floor plan ' + this.floorPlan.notes + ' has been deleted.');

      } else if (res.code === 0) {
        this.toastr.error('Failed to delete this floor plan');
      }
    });
  }
}
